import { render, staticRenderFns } from "./accessManage.vue?vue&type=template&id=097933f1&scoped=true&"
import script from "./accessManage.vue?vue&type=script&lang=ts&"
export * from "./accessManage.vue?vue&type=script&lang=ts&"
import style0 from "./accessManage.vue?vue&type=style&index=0&id=097933f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097933f1",
  null
  
)

export default component.exports